import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { ISidebar } from '../../types/sidebar';
import { API_INTERACT_URL, axiosInt } from '../../';

export const FETCH_SIDEBAR_KEY = 'fetchSidebar';
export const fetchSidebarsApi = async (): Promise<ISidebar[]> => {
  const response = await axiosInt.get(`${API_INTERACT_URL}/sidebars`);
  return response.data;
};

const useFetchSidebars = (options?: Partial<UseQueryOptions<ISidebar[]>>) => {
  const {
    data: sidebar,
    isLoading: isLoadingSidebar,
    error: errorFetchingSidebar,
  } = useQuery<ISidebar[]>({
    queryKey: [FETCH_SIDEBAR_KEY],
    queryFn: () => fetchSidebarsApi(),
    ...options,
  });

  return { sidebar, isLoadingSidebar, errorFetchingSidebar };
};

export default useFetchSidebars;
